import React from 'react';

import './CanvasComponent.css';

var CanvasObject = (function () {
    //Constructors
    function CanvasObject(x, y, color, strokeColor, velocityX, velocityY, radius, decay) {
        if (color === void 0) { color = "white"; }
        if (strokeColor === void 0) { strokeColor = "white"; }
        if (velocityX === void 0) { velocityX = 0; }
        if (velocityY === void 0) { velocityY = 0; }
        this.x = x;
        this.y = y;
        this.color = color;
        this.strokeColor = strokeColor;
        this.velocityX = velocityX;
        this.velocityY = velocityY;
        this.radius = radius;
        this.decay = decay;
        this.alpha = 1;
    }
    //Methods
    CanvasObject.prototype.update = function () {
        this.x += this.velocityX;
        this.y += this.velocityY;
        if (this.decay && this.radius > 0) {
            this.radius -= 1;
            if (this.radius < 0) {
                this.radius = 0;
            }
        }

        if (this.decay && this.globalAlpha > 0) {
            this.alpha -= 0.1;
            if (this.alpha < 0) {
                this.alpha = 0;
            }
        }
    };
    CanvasObject.prototype.draw = function (ctx) {
        var isContextAvailable = typeof ctx !== "undefined" && ctx !== undefined;
        if (isContextAvailable) {
            ctx.globalAlpha = this.alpha;
            ctx.fillStyle = this.color;
            ctx.strokeStyle = this.strokeColor;
            ctx.beginPath();
            ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2, false);
            ctx.fill();
            ctx.closePath();
        }
        return isContextAvailable;
    };
    CanvasObject.prototype.intersectsWithBorder = function (canvas) {
        var result = false;
        if (typeof canvas !== "undefined"
            && canvas !== undefined) {
            if (this.x - this.radius < 0
                || this.x + this.radius > canvas.width) {
                this.velocityX *= -1;
                result = true;
            }
            if (this.y - this.radius < 0
                || this.y + this.radius > canvas.height) {
                this.velocityY *= -1;
                result = true;
            }
        }
        return result;
    };
    CanvasObject.prototype.intersects = function (obj) {
        return (this.getDistance(obj) < (this.radius + obj.radius));
    };

    CanvasObject.prototype.getDistance = function (obj) {
        var xDistance = Math.max(this.x, obj.x) - Math.min(this.x, obj.x);
        var yDistance = Math.max(this.y, obj.y) - Math.min(this.y, obj.y);
        // c = sqrt(a^2 + b^2);
        return Math.sqrt(Math.pow(xDistance, 2) + Math.pow(yDistance, 2));
    };

    return CanvasObject;
}());

class CanvasComponent extends React.Component {

    componentDidMount() {
        this.updateCanvas();
    }

    updateCanvas() {
        var canvas = this.refs.canvas;
        var ctx = canvas.getContext('2d');
        var objects = [];
        var fxs = [];
        var framerate = 60;
        
        function init() {
          for (var i = 0; i < Math.floor(window.innerWidth / 50); i++) {
            objects.push(new CanvasObject(
                randomIntFromRange(20, canvas.width - 20),
                randomIntFromRange(20, canvas.height - 20),
                "rgba(44, 62, 80, 0.2)",
                "rgba(44, 62, 80, 0.2)",
                randomFloatFromRange(-0.5, 0.5, 2),
                randomFloatFromRange(-0.5, 0.5, 2),
                10,
                false
            ));
          }
          
          setInterval(animate , 1000 / framerate);
        }
        
        //Animation Loop
        function animate() {
          ctx.clearRect(0,0,canvas.width, canvas.height);
          
          for (var fx of fxs) {
            fx.update();
            fx.draw(ctx);
          }
          
          for (var obj of objects) {
            for (var obj2 of objects) {
              if (obj === obj2) {
                continue;
              }
              
              if (obj.intersects(obj2)) {
                var fx = new CanvasObject(
                    obj.x,
                    obj.y,
                    "rgba(52, 152, 219, 0.1)",
                    "rgba(52, 152, 219, 0.0)",
                    randomFloatFromRange(-5, 5, 2),
                    randomFloatFromRange(-5, 5, 2),
                    10,
                    true
                );
                fxs.push(fx);
                setTimeout(function() {
                  fxs.shift();
                }, 2000);
              }
            }
            
            obj.intersectsWithBorder(canvas)
            obj.update();
            obj.draw(ctx);
          }
        }
        
        init();
    }

    render() {
        return (
            <div className='canvascomponent_wrapper'>
                <canvas ref="canvas" width={window.innerWidth} height={window.innerHeight}></canvas>
            </div>
        );
    }
}

//Utility functions
function randomIntFromRange(min,max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}

function randomFloatFromRange(min, max, n){
    return parseFloat(Math.min(min + (Math.random() * (max - min)), max).toFixed(n));
}

export default CanvasComponent;


// WEBPACK FOOTER //
// ./src/CanvasComponent/CanvasComponent.react.js